import { useEffect, useState } from 'react'
import { getWindowSize } from 'redesign/utils/getWindowSize'

type useWindowSizeType = {
    sm: boolean
    md: boolean
    lg: boolean
    lessThan: {
        sm: boolean
        md: boolean
        lg: boolean
    }
    greaterThan: {
        sm: boolean
        md: boolean
        lg: boolean
    }
}

export const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState<useWindowSizeType>(getWindowSize())

    useEffect(() => {
        const changeWindowSize = () => {
            setWindowSize(getWindowSize())
        }

        window.addEventListener('resize', changeWindowSize)
        return () => window.removeEventListener('resize', changeWindowSize)
    }, [])

    return { windowSize }
}
